export enum DestinationTypeDetailEnum {
    WindowsAgent = "WindowsAgent",
    LinuxDebAgent = "LinuxDebAgent",
    LinuxRpmAgent = "LinuxRpmAgent",
    macOSAgent = "macOSAgent",
    Wordpress = "Wordpress",
    DotNet = "DotNet"
}